<template>
  <div>
    <div class="odmik-dodajanja-narocnine vsebina-inline" v-if="!moznostVnosaSmsPotrditve">
      <div class="open-sans-16pt">
        <b>
          Povezava naročnine s podatki naročniškega razmerja
        </b>
      </div>
      <div class="postavitev-input">
        <el-form label-width="170px" :label-position="formaOrientacija"
                 ref="narocninaForm"
                 class="nova-vrstica-forma"
                 @submit.native.prevent="GetPotrditvenoGeslo"
                 :model="novaNarocnina"
                 :rules="novaNarocninaRules">
          <el-form-item label="Številka kupca" prop="sap">
            <el-input placeholder="Vnesite številko kupca"
                      v-model="novaNarocnina.sap"
                      class="velikost-inputa">
            </el-input>
            <div class="odmik-info-vsebine">
              <p class="velikost-pisave-info">
                <i class="fa fa-info-circle" aria-hidden="true"></i>
                Številko kupca najdete na
                <a :href="stranRacunStevilkaKupca" class="primarna-barva" target="_blank">
                  mesečnem računu
                </a>
                T-2.
              </p>
            </div>
          </el-form-item>
          <el-form-item label="Davčna številka" prop="davcna" class="class-davcna-stevilka">
            <el-input placeholder="Vnesite davčno številko"
                      v-model="novaNarocnina.davcna"
                      class="velikost-inputa">
            </el-input>
          </el-form-item>
          <!--          <el-form-item prop="preverjanjeStarosti">-->
          <!--            <el-checkbox v-model="novaNarocnina.preverjanjeStarosti">-->
          <!--              Potrjujem, da sem star/-a 18 let-->
          <!--            </el-checkbox>-->
          <!--          </el-form-item>-->
        </el-form>
      </div>
      <div class="odmik-gumba">
        <el-button type="primary" class="gumb-potrdi gumb-potrdi-sirina" @click="GetPotrditvenoGeslo"
                   :loading="novaNarocninaBtnLoader">
          DODAJ NAROČNINO
        </el-button>
      </div>
    </div>
    <div v-if="moznostVnosaSmsPotrditve && prikaziFormoZaSmsNovo">
      <p class="navadno-besedilo levo-brez-odmika">
        Za uspešno povezavo prosimo vpišite geslo, ki smo vam ga pravkar poslali na kontaktno mobilno številko, ki
        se konča z {{gsmZaPrikaz}}.
      </p>
      <el-form label-width="170px"
               ref="potrdiNarocninoForm"
               :label-position="formaOrientacija"
               class="nova-vrstica-forma"
               @submit.native.prevent="DodajNarocnino"
               :model="token"
               :rules="tokenRules">
        <el-form-item label="Potrditveno geslo" prop="geslo">
          <el-input placeholder="Vpišite geslo" v-model="token.geslo" class="velikost-inputa">
          </el-input>
        </el-form-item>
      </el-form>
      <div class="odmik-gumba">
        <el-button type="primary" @click="DodajNarocnino" class="gumb-potrdi gumb-potrdi-sirina"
                   :loading="novaNarocninaBtnLoader">
          POTRDI GESLO
        </el-button>
        <a class="stil-gumb-preklici" @click="PrekliciDodajanjeNarocnine" type="primary">
          PREKLIČI
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {Input, Button, Collapse, CollapseItem, Col} from 'element-ui'
import ClientAgent from '../../../../../../assets/js/clientAgent.js'
import {PrikazVsebine} from '../../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna'
import {povezave} from '../../../../../../assets/js/Povezave/povezave'
import {HTTPResponseCodes} from '../../../../../../assets/js/Enum/ResponseCodes/HTTPResponseCodes'

export default {
  name: 'DodajNovo',
  mixins: [PrikazVsebine],
  components: {
    [Button.name]: Button,
    [Input.name]: Input,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Col.name]: Col
  },
  data () {
    return {
      stranRacunStevilkaKupca: '',
      clientAgent: null,
      formaOrientacija: 'left',
      mejnaSirina: 600,
      novaNarocninaBtnLoader: false,
      prikaziFormoZaSmsNovo: false,
      token: {
        geslo: ''
      },
      tokenRules: {
        geslo: [
          {required: true, message: 'Prosimo, vpišite potrditveno geslo.', trigger: 'blur'},
          {min: 6, message: 'Potrditveno geslo mora vsebovati vsaj 6 znakov.'}
        ]
      },
      novaNarocnina: {
        sap: '',
        davcna: ''
        // preverjanjeStarosti: []
      },
      novaNarocninaRules: {
        sap: [
          {
            validator: this.ValidirajSap
          }
        ],
        davcna: [
          {
            validator: this.ValidirajDavcno
          }
        ]
        // preverjanjeStarosti: [
        //   {
        //     validator: this.ValidirajStarost
        //   }
        // ]
      },
      gsmZaPrikaz: ''
    }
  },
  props: {
    moznostVnosaSmsPotrditve: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednost)
      window.dispatchEvent(new Event('resize'))
    })
    this.stranRacunStevilkaKupca = povezave.BASE_URL_RACUN_STEVILKA_KUPCA
  },
  methods: {
    ValidirajStarost (rule, starost, callback) {
      if (starost.length === 0) {
        return callback(new Error('Prosim potrdite, da ste starejši od 18 let.'))
      }
      callback()
    },
    GetPotrditvenoGeslo () {
      let isValid = false
      this.$refs['narocninaForm'].validate((valid) => {
        isValid = valid
      })
      if (!isValid) {
        return false
      }
      this.novaNarocninaBtnLoader = true
      let param = ['sap=' + this.novaNarocnina.sap]
      param.push('taxNumber=' + this.novaNarocnina.davcna)
      this.clientAgent.postWsRequest(
        this,
        'subscriptions/getConfirmationPassword?',
        param,
        null,
        'SetPotrditvenoGeslo',
        'ErrPotrditvenoGeslo')
    },
    SetPotrditvenoGeslo (podatki) {
      this.novaNarocninaBtnLoader = false
      if (podatki.gsmNumber !== '') {
        this.gsmZaPrikaz = podatki.gsmNumber
      }
      // this.novaNarocnina.preverjanjeStarosti = []
      this.ShowSuccessMessage(podatki)
      this.$emit('posodobiTokenFormo', true)
      this.prikaziFormoZaSmsNovo = true
    },
    ErrPotrditvenoGeslo (podatki) {
      let paramObvestilo = {}
      if (podatki.statusCode === HTTPResponseCodes.UNAUTHORIZED) {
        paramObvestilo.message = 'Naročniški podatki se ne ujemajo s podatki, vnesenimi na pogodbi.\n' +
          'Prosimo, da se oglasite v T-2 poslovalnici in uredite ustreznost podatkov.\n' +
          'Za pomoč smo na voljo tudi na številki 064 064 064.'
      } else {
        paramObvestilo.message = podatki.message
      }
      this.novaNarocninaBtnLoader = false
      this.ShowWarningMessage(paramObvestilo)
    },
    ValidirajDavcno (rule, davcna, callback) {
      if (!davcna) {
        return callback(new Error('Davčna številka je obvezna.'))
      }
      const value = String(davcna)
      // Ne dovolimo drugih znakov.
      // Dovoljene so samo črke A-Z/a-z in številke.
      const allowedCharsRegex = /^[A-Za-z0-9]+$/
      if (!allowedCharsRegex.test(value)) {
        return callback(
          new Error('Davčna številka ne sme vsebovati presledkov ali posebnih znakov.')
        )
      }
      const normalizedValue = value.toUpperCase()
      // Ne dovolimo, da so vse številke ničle, seveda brez predpon.
      const numericPart = normalizedValue.replace(/[A-Z]/g, '')
      if (numericPart && /^0+$/.test(numericPart)) {
        return callback(
          new Error('Davčna številka ne sme biti sestavljena samo iz ničel.')
        )
      }
      // Če ima slovensko SI predpono se preveri le ta!
      if (normalizedValue.startsWith('SI')) {
        const slovenskaDavcnaRegex = /^SI\d{8}$/
        if (!slovenskaDavcnaRegex.test(normalizedValue)) {
          return callback(
            new Error('Slovenska davčna številka mora biti v formatu SI + 8 številk.')
          )
        }
        return callback()
      }
      // Mednarodna mehka validacija davčnih/ID številk: 5 do 15 alfanumeričnih znakov.
      const globalTinRegex = /^[A-Z0-9]{5,15}$/
      if (!globalTinRegex.test(normalizedValue)) {
        return callback(
          new Error('Vpisana davčna številka ni ustreznega formata.')
        )
      }
      callback()
    },
    ValidirajSap (rule, sap, callback) {
      let sapRegex = new RegExp('^[0-9]{1,10}')
      let isValid = sapRegex.test(sap)
      if (!isValid) {
        let msg = 'Vpisana številka kupca ni ustreznega formata.'
        return callback(new Error(msg))
      } else {
        callback()
      }
    },
    DodajNarocnino () {
      let isValid = false
      this.$refs['potrdiNarocninoForm'].validate((valid) => {
        isValid = valid
      })
      if (!isValid) {
        return false
      }
      this.novaNarocninaBtnLoader = true
      let param = ['sap=' + this.novaNarocnina.sap]
      param.push('taxNumber=' + this.novaNarocnina.davcna)
      param.push('confirmationCode=' + this.token.geslo)
      this.clientAgent.postWsRequest(this,
        'subscriptions/add',
        param,
        null,
        'SetDodajNarocnino',
        'ErrDodajNarocnino',
        90000
      )
    },
    SetDodajNarocnino () {
      this.novaNarocninaBtnLoader = false
      this.novaNarocnina.sap = ''
      this.novaNarocnina.davcna = ''
      this.ShowSuccessMessage({'message': 'Uspešno dodana naročnina.'})
      this.$emit('posodobiTokenFormo', false)
      this.$emit('osveziPodatke')
      this.prikaziFormoZaSmsNovo = false
    },
    ErrDodajNarocnino (err) {
      this.novaNarocninaBtnLoader = false
      this.ShowWarningMessage({'message': 'Napaka pri dodajanju: ' + err.message})
    },
    PrekliciDodajanjeNarocnine () {
      this.$emit('posodobiTokenFormo', false)
      this.novaNarocnina.sap = ''
      this.novaNarocnina.davcna = ''
      this.novaNarocninaBtnLoader = false
    }
  }
}
</script>
<style scoped>
.fa {
  font-size: 15px !important;
  color: black !important;
  position: absolute;
  left: 0;
}

p {
  width: 100%;
  position: relative;
  padding-left: 25px;
}

.velikost-pisave-info {
  font-size: 12px;
}

.odmik-info-vsebine {
  padding-top: 10px;
}
</style>
<style scoped src="../../../../../../../static/css/Narocnine/DodajanjeNarocnin.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/DodajanjeNarocnin/DodajanjeNarocninKomponente/DodajNovo.vue